import React from 'react';

// Material-UI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

// Styles
import { useTheme } from '@mui/material/styles';

interface EmailFormHelpDialogProps {
  show: boolean;
  handleClose: () => void;
}

const EmailFormHelpDialog: React.FC<EmailFormHelpDialogProps> = (props) => {

  // #region Styles

  const theme = useTheme();
  const styles = {
    divider: {
      margin: theme.spacing(2, 0, 2, 0),
    },
  }

  // #endregion

  return (
    <Dialog
      open={props.show}
      onClose={props.handleClose}
    >
      <DialogTitle>Lodge Use Email</DialogTitle>
      <DialogContent>
        <Typography component="div" variant="body1">
          <ul>
            <li>The email will be sent to the selected member(s)</li>
            <li>Non-members that are part of a household will receive emails if they have an email address</li>
            <li>Guests are not included in lodge use emails</li>
            <li>Enter the subject and message content</li>
          </ul>
        </Typography>
        <Divider sx={styles.divider} />
        <Typography variant="body2">One or more PDF or .docx attachments can be included, max 10 MB each, and must be added individually.</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.handleClose()} color="primary">Close</Button>
      </DialogActions>
    </Dialog>
  );

}

export default EmailFormHelpDialog;